import { Pressable, View } from "react-native"
import BFLogo from "@/assets/logo/backflip-logo.svg"
import { router, usePathname } from "expo-router"
import { H4 } from "@/components/standard/BFText"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { BFColors } from "@/constants/Colors"
import LoanProducts from "@/screens/loans/components/LoanProducts"
import {
  BottomSheetBackdrop,
  type BottomSheetBackdropProps,
  BottomSheetModal,
} from "@gorhom/bottom-sheet"
import { useCallback, useRef } from "react"

const BFDesktopTab = ({
  title,
  selected,
  onPress,
}: {
  title: string
  selected: boolean
  onPress: () => void
}) => (
  <Pressable
    testID={"tab-" + title.toLowerCase()}
    onPress={onPress}
    className={`p-2 mt-5 border-light-grey cursor-pointer rounded-t-lg justify-center items-center`}
  >
    <H4 className={`p-1 text-off-white`}>{title}</H4>
    <View
      className={`h-[2px] ${!selected ? "bg-transparent" : "bg-teal"} w-full self-center max-w-5`}
    ></View>
  </Pressable>
)

export const BFDeskopHeader = () => {
  const pathname = usePathname()
  const insets = useSafeAreaInsets()
  const bottomSheetModalRef = useRef<BottomSheetModal>(null)

  const renderBackdrop = useCallback(
    (props: BottomSheetBackdropProps) => (
      <BottomSheetBackdrop
        {...props}
        appearsOnIndex={0}
        disappearsOnIndex={-1}
      />
    ),
    []
  )

  console.log(
    `>> '${pathname}'`,
    pathname === "/",
    pathname.startsWith("/loans")
  )

  return (
    <View
      testID={"bfDesktopHeader"}
      id={"bfDesktopHeader"}
      style={{
        paddingTop: insets.top,
      }}
      className={
        "bg-midnight-blue flex-row justify-between border-b-calm-blue border-b border-light-grey"
      }
    >
      <View className="flex-row px-9 justify-between items-center w-full">
        <Pressable
          testID={"header-logo"}
          onPress={() => {
            router.push("/")
          }}
        >
          <BFLogo width={150} height={45} />
        </Pressable>
        <View className="items-center gap-1 flex-row p-3">
          <BFDesktopTab
            selected={pathname === "/"}
            title={"Home"}
            onPress={() => {
              router.push("/")
            }}
          />
          <BFDesktopTab
            selected={pathname.startsWith("/properties")}
            title={"Properties"}
            onPress={() => {
              router.push("/properties")
            }}
          />
          <BFDesktopTab
            selected={pathname.startsWith("/analyze")}
            title={"Analyze"}
            onPress={() => {
              router.push("/analyze")
            }}
          />
          <BFDesktopTab
            title={"Loans"}
            selected={pathname.startsWith("/loans")}
            onPress={() => {
              router.push("/loans")
            }}
          />
          <BFDesktopTab
            title={"Events"}
            selected={pathname.startsWith("/events")}
            onPress={() => {
              router.push("/events")
            }}
          />
          <BFDesktopTab
            title={"Account"}
            selected={pathname.startsWith("/account")}
            onPress={() => {
              router.push("/account")
            }}
          />
        </View>
      </View>
      <BottomSheetModal
        ref={bottomSheetModalRef}
        snapPoints={["80%"]}
        backdropComponent={renderBackdrop}
        index={0}
        backgroundStyle={{ backgroundColor: "#FFFFFF" }}
        handleIndicatorStyle={{ backgroundColor: BFColors.calmBlue }}
        enableDynamicSizing={false}
      >
        <LoanProducts
          onDismiss={() => {
            bottomSheetModalRef.current?.dismiss()
          }}
        />
      </BottomSheetModal>
    </View>
  )
}
